import React, { ReactNode, useEffect, useRef, useState } from "react";
import { Swiper, SwiperClass } from "swiper/react";
import { Navigation } from "swiper/modules";
import "swiper/css";
import "swiper/css/navigation";

import { CenteredSwiperContext } from "./CenteredSwiperContext";
import { centeredSwiperConfiguration } from "./centeredSwiperConfig";

import { Button } from "@components/buttons";

export function CenteredSwiper({
	children,
	customClass,
}: {
	children: ReactNode;
	customClass?: string;
}) {
	const prevRef = useRef<any>(null);
	const nextRef = useRef<any>(null);

	const [swiper, setSwiper] = useState<SwiperClass | null>(null);
	const [selectedSlideIndex, setSelectedSlideIndex] = useState(0);

	useEffect(() => {
		const timer = setTimeout(() => swiper?.slideTo(selectedSlideIndex), 0);
		return () => clearTimeout(timer);
	}, [selectedSlideIndex]);

	return (
		<CenteredSwiperContext.Provider value={{ setSelectedSlideIndex }}>
			<div className="tabs tabs--swiper">
				<Button
					ref={prevRef}
					type="button"
					className="btn--round btn--round--sml btn--primary--inverted tabs--swiper__prev"
					iconOnly
					iconClassName="u-icon--tny u-icon--arrow-left"
				/>

				<Button
					ref={nextRef}
					type="button"
					className="btn--round btn--round--sml btn--primary--inverted tabs--swiper__next"
					iconOnly
					iconClassName="u-icon--tny u-icon--arrow-right"
				/>

				<Swiper
					{...centeredSwiperConfiguration}
					modules={[Navigation]}
					navigation={{
						prevEl: prevRef.current,
						nextEl: nextRef.current,
					}}
					onBeforeInit={(swiper) => {
						swiper.navigation.nextEl = nextRef.current;
						swiper.navigation.prevEl = prevRef.current;
					}}
					onInit={(swiper) => {
						// @ts-ignore
						swiper.params.navigation.prevEl = prevRef.current;
						// @ts-ignore
						swiper.params.navigation.nextEl = nextRef.current;
						swiper.navigation.init();
						swiper.navigation.update();
						setSwiper(swiper);
					}}
					onResize={(swiper) => swiper.slideTo(selectedSlideIndex)}
					className={customClass}
				>
					{children}
				</Swiper>
			</div>
		</CenteredSwiperContext.Provider>
	);
}
